<template>


    <div id="aside" class="page-sidenav no-shrink  nav-expand  animate fadeInLeft fade" aria-hidden="true">
        <div class="sidenav h-100 modal-dialog bg-white box-shadow">
            <!-- sidenav top -->
            <!-- Flex nav content -->
            <div class="flex scrollable hover">
                <div class="nav-border b-primary" data-nav>
                    <ul class="nav bg">
                        <li class="nav-header hidden-folded">
                            <span>Main</span>
                        </li>
                        <li>
                            <a href="dashboard.html" class="i-con-h-a">
		                  <span class="nav-icon">
		                    <i class="i-con i-con-home"><i></i></i>
		                  </span>
                                <span class="nav-text">Dashboard</span>
                            </a>
                        </li>




                        <li class="nav-header hidden-folded">
                            <span>Appwork</span>
                        </li>


                        <li v-for="menuEntry in menuEntries">
                        <MainMenuElement
                                :title="menuEntry.title"
                                :target="menuEntry.target"
                                :icon="menuEntry.icon"
                                :count="menuEntry.count"
                        />
                        </li>

                        <li class="nav-header hidden-folded">
                            <span>Apps</span>
                        </li>
                        <li>
                            <a href="app.calendar.html" class="i-con-h-a">
		                  <span class="nav-icon">
		                    <i class="i-con i-con-calendar"><i></i></i>
		                  </span>
                                <span class="nav-text">Calendar</span>
                            </a>
                        </li>

                        <li>
                            <a href="app.mail.html" class="i-con-h-a">
		                  <span class="nav-icon">
		                    <i class="i-con i-con-mail"><i></i></i>
		                  </span>
                                <span class="nav-text">Email</span>
                                <span class="nav-badge">
		                    <b class="badge badge-sm badge-pill bg-primary">7</b>
		                  </span>
                            </a>
                        </li>
                        <li>
                            <a href="app.message.html" class="i-con-h-a">
		                  <span class="nav-icon">
		                    <i class="i-con i-con-comment"><i></i></i>
		                  </span>
                                <span class="nav-text">Messages</span>
                                <span class="nav-badge">
		                    <b class="badge badge-sm badge-pill bg-danger">11</b>
		                  </span>
                            </a>
                        </li>
                        <li>
                            <a href="app.user.html" class="i-con-h-a">
		                  <span class="nav-icon">
		                    <i class="i-con i-con-users"><i></i></i>
		                  </span>
                                <span class="nav-text">Users</span>
                            </a>
                        </li>
                    </ul>
                    <ul class="nav ">
                        <li class="nav-header hidden-folded">
                            <span>UI elements</span>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-layer'><i></i></i>
		                      </span>
                                <span class="nav-text">Components</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="ui.alert.html" class="">
                                        <span class="nav-text">Alert</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.badge.html" class="">
                                        <span class="nav-text">Badge</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.button.html" class="">
                                        <span class="nav-text">Button</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.card.html" class="">
                                        <span class="nav-text">Card</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.carousel.html" class="">
                                        <span class="nav-text">Carousel</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.color.html" class="">
                                        <span class="nav-text">Color</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.dropdown.html" class="">
                                        <span class="nav-text">Dropdown</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.grid.html" class="">
                                        <span class="nav-text">Grid</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.icon.html" class="">
                                        <span class="nav-text">Icon</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.list.html" class="">
                                        <span class="nav-text">List</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.modal.html" class="">
                                        <span class="nav-text">Modal</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.navbar.html" class="">
                                        <span class="nav-text">Navbar</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.sidenav.html" class="">
                                        <span class="nav-text">Sidenav</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.timeline.html" class="">
                                        <span class="nav-text">Timeline</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.tab.html" class="">
                                        <span class="nav-text">Tab &amp; Collpase</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.tooltip.html" class="">
                                        <span class="nav-text">Tooltip &amp; Popover</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-grid'><i></i></i>
		                      </span>
                                <span class="nav-text">Plugins</span>
                                <span class="nav-badge">
		                        <b class="badge badge-sm badge-pill ">5</b>
		                      </span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="ui.scroll.html" class="">
                                        <span class="nav-text">Infinite Scroll</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.sortable.html" class="">
                                        <span class="nav-text">Sortable</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.scrollreveal.html" class="">
                                        <span class="nav-text">Scroll Reveal</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="ui.map.html" class="">
                                        <span class="nav-text">Vector Map</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-circle'><i></i></i>
		                      </span>
                                <span class="nav-text">Form</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="form.element.html" class="">
                                        <span class="nav-text">Form Element</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.layout.html" class="">
                                        <span class="nav-text">Form Layout</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.validation.html" class="">
                                        <span class="nav-text">Form Validation</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.editor.html" class="">
                                        <span class="nav-text">Editor</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.datepicker.html" class="">
                                        <span class="nav-text">Datepicker</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.select.html" class="">
                                        <span class="nav-text">Select</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.wizard.html" class="">
                                        <span class="nav-text">Wizard</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="form.dropzone.html" class="">
                                        <span class="nav-text">File Upload</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-table'><i></i></i>
		                      </span>
                                <span class="nav-text">Tables</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="table.style.html" class="">
                                        <span class="nav-text">Style</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="table.bootstrap.html" class="">
                                        <span class="nav-text">Bootstrap Table</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="table.datatables.html" class="">
                                        <span class="nav-text">Datatables</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-pie-chart'><i></i></i>
		                      </span>
                                <span class="nav-text">Charts</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="chart.simple.html" class="">
                                        <span class="nav-text">Simple</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="chart.chartjs.html" class="">
                                        <span class="nav-text">Chartjs</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-header hidden-folded">
                            <span>Extra</span>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-page'><i></i></i>
		                      </span>
                                <span class="nav-text">Pages</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="page.profile.html" class="">
                                        <span class="nav-text">Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.search.html" class="">
                                        <span class="nav-text">Search</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.invoice.html" class="">
                                        <span class="nav-text">Invoice</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.faq.html" class="">
                                        <span class="nav-text">FAQ</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.price.html" class="">
                                        <span class="nav-text">Price</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.setting.html" class="">
                                        <span class="nav-text">Setting</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="page.blank.html" class="">
                                        <span class="nav-text">Blank</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#" class="i-con-h-a">
		                      <span class="nav-icon">
		                        <i class='i-con i-con-lock'><i></i></i>
		                      </span>
                                <span class="nav-text">Auth</span>
                                <span class="nav-caret"></span>
                            </a>

                            <ul class="nav-sub">
                                <li>
                                    <a href="signin.html" class="">
                                        <span class="nav-text">Signin</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="signup.html" class="">
                                        <span class="nav-text">Signup</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="forgot-password.html" class="">
                                        <span class="nav-text">Forgot Password</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="lockme.html" class="">
                                        <span class="nav-text">Lockme Screen</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="404.html" class="">
                                        <span class="nav-text">Error 404</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="505.html" class="">
                                        <span class="nav-text">Error 505</span>
                                    </a>
                                </li>
                            </ul>
                        </li>


                    </ul>
                </div>
            </div>

            <!-- sidenav bottom -->
            <div class="no-shrink ">
                <div class="text-sm p-3 b-t">
                    <div class="hidden-folded text-sm">
                        <div class="mt-1">
                            <a href="index.html" class="text-muted">About</a>
                            <a href="../docs/" class="text-muted mx-2 no-ajax" target="_blank">Documentation</a>
                        </div>
                        <div class="text-muted">
                            <small class="text-muted">&copy; Copyright 2018, Appwork</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import MainMenuElement from "./MainMenuElement";

    export default {
        name: "MainMenu",
        components: {MainMenuElement},
        data: function () {

            return {
                menuEntries: [
                    {
                        title: 'Dashboard',
                        target: 'Dashboard',
                        icon: 'i-con-home'
                    },
                    {
                        title: 'Kunden',
                        target: 'CustomerDashboard',
                        icon: 'i-con-users'
                    },
                    {
                        title: 'Projekte',
                        target: 'ProjectDashboard',
                        icon: 'i-con-grid',
                        count: 8
                    },
                    {
                        title: 'Rechnungen',
                        target: 'InvoiceDashboard',
                        icon: 'i-con-page'
                    },
                    {
                        title: 'Dokumente',
                        target: 'DocumentDashboard',
                        icon: 'i-con-layer'
                    }
                ]
            }
        },
        comments: {
            MainMenuElement
        }
    }
</script>

<style scoped lang="scss">

    @import "~styles/colors";

    .sidenav {
        margin: 0 !important;
        font-size: 0.875rem;
        color: rgb(100, 119, 135);

    }

    .router-link-active {
        background-color: rgba(19, 126, 255, 0.05);
        border-left: 3px solid rgb(19, 126, 255);
        color: rgb(19, 126, 255);
    }
    /*
    .main-menu__container {
        padding-top: 3rem;
        border-right: 1px solid $border-color;
        background-color: lighten(#eeeeee, 5%);
    }


    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    li {
        padding: 0.6rem 0;
    }
    */
</style>